export const GET_PLANS_REQUEST = 'GET_PLANS_REQUEST'
export const GET_PLANS = 'GET_PLANS'
export const CREATE_PLAN_REQUEST = 'CREATE_PLAN_REQUEST'
export const CREATE_PLAN = 'CREATE_PLAN'
export const UPDATE_PLAN_REQUEST = 'UPDATE_PLAN_REQUEST'
export const UPDATE_PLAN = 'UPDATE_PLAN'

export const GET_SUBSCRIPTIONS_REQUEST = 'GET_SUBSCRIPTIONS_REQUEST'
export const GET_SUBSCRIPTIONS = 'GET_SUBSCRIPTIONS'
export const GET_SUBSCRIPTION_REQUEST = 'GET_SUBSCRIPTION_REQUEST'
export const GET_SUBSCRIPTION = 'GET_SUBSCRIPTION'
export const CREATE_SUBSCRIPTION_REQUEST = 'CREATE_SUBSCRIPTION_REQUEST'
export const CREATE_SUBSCRIPTION = 'CREATE_SUBSCRIPTION'
export const UPDATE_SUBSCRIPTION_REQUEST = 'UPDATE_SUBSCRIPTION_REQUEST'
export const UPDATE_SUBSCRIPTION = 'UPDATE_SUBSCRIPTION'

export const GET_SUBSCRIPTIONS_REQUEST_PENDING = 'GET_SUBSCRIPTIONS_REQUEST_PENDING'
export const GET_SUBSCRIPTIONS_REQUEST_SUCCESS = 'GET_SUBSCRIPTIONS_REQUEST_SUCCESS'
export const GET_SUBSCRIPTIONS_REQUEST_ERROR = 'GET_SUBSCRIPTIONS_REQUEST_ERROR'

export const CHANGE_SUBSCRIPTIONS_REQUEST_PENDING = 'CHANGE_SUBSCRIPTIONS_REQUEST_PENDING'
export const CHANGE_SUBSCRIPTIONS_REQUEST_SUCCESS = 'CHANGE_SUBSCRIPTIONS_REQUEST_SUCCESS'
export const CHANGE_SUBSCRIPTIONS_REQUEST_ERROR = 'CHANGE_SUBSCRIPTIONS_REQUEST_ERROR'

export const GET_CUSTOMER_SUBSCRIPTIONS_REQUEST = 'GET_CUSTOMER_SUBSCRIPTIONS_REQUEST'
export const GET_CUSTOMER_SUBSCRIPTIONS = 'GET_CUSTOMER_SUBSCRIPTIONS'
export const GET_CUSTOMER_SUBSCRIPTIONS_REQUEST_PENDING = 'GET_CUSTOMER_SUBSCRIPTIONS_REQUEST_PENDING'
export const GET_CUSTOMER_SUBSCRIPTIONS_REQUEST_SUCCESS = 'GET_CUSTOMER_SUBSCRIPTIONS_REQUEST_SUCCESS'
export const GET_CUSTOMER_SUBSCRIPTIONS_REQUEST_ERROR = 'GET_CUSTOMER_SUBSCRIPTIONS_REQUEST_ERROR'
